import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/medicalPatient/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/medicalPatient/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/medicalPatient/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/medicalPatient/video/sub/rtlsVideo3.mp4';

export default {
  type: '의료 솔루션',
  banner: {
    title: '환자 안전을 지키는 RTLS 기반 실시간 위치관리',
    desc: '환자의 위치를 병원 내에서 정확히 추적하여 낙상·이탈·접촉 감염 등 안전 사고를 예방하고, 운영 인력과 비용 부담을 줄이면서 의료 리소스를 효율적으로 배치할 수 있습니다.',
  },

  video: {
    title: 'RTLS로 의료 현장의 시야를 확장하고, 안전·운영을 실시간으로 관리하세요',
    desc: '환자 동선을 실시간 모니터링해 위험 접근이나 이상 상황을 자동 감지하고, 낙상 알림·접촉자 추적·이탈 감지 등을 자동화하여 사고 대응과 증빙을 빠르게 지원합니다.',
    play: video,
  },

  func: [
    {
      theme: '환자 안전 및 이상 상황 실시간 감지',
      title: '실시간 위치 추적 및 경로 시각화',
      desc: '환자 ID 태그를 통해 병원 내부에서 환자의 위치와 동선을 실시간으로 확인할 수 있으며, 지정 구역 접근 시 관리자에게 즉시 알림이 발송됩니다. 이를 통해 응급 상황에 신속하게 대응하고 낙상, 실종 등 사고 발생 가능성을 최소화할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      video: subVideo1,
    },
    {
      title: '낙상 및 이상 동작 감지',
      desc: '노인 환자나 거동이 불편한 환자의 낙상 가능성을 분석하여 AI 기반으로 자동 감지하고, 해당 위치에 신속하게 의료진이 도착할 수 있도록 알림을 제공합니다. 환자의 안전을 지속적으로 모니터링할 수 있습니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
    {
      title: '고위험 구역 이탈 감지 및 경고',
      desc: '중환자실·격리구역·장애인 전용 공간 등에서 벗어날 경우 자동 알람이 발송되며, 시스템은 해당 환자의 현재 위치를 빠르게 파악해 안전사고를 방지합니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      video: subVideo3,
    },
    {
      title: '접촉자 추적 및 감염 관리 지원',
      desc: '감염병 상황 시 환자의 이동 동선을 기반으로 접촉자 리스트를 자동 생성하며, 방역 대응 시간을 최소화할 수 있어 병원 전체의 감염 관리 효율이 향상됩니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
    {
      theme: '운영 효율 및 리포팅 자동화',
      title: '동선 분석 기반 병목 예방',
      desc: '환자 동선 데이터를 분석해 혼잡 시간대와 공간을 파악하고, 병동과 검사실 간의 이동 병목 현상을 줄일 수 있어 병원 전체 운영의 효율을 높입니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo1,
    },
    {
      title: 'KPI 기반 안전 리포트 제공',
      desc: '낙상 횟수, 이탈 사건, 이상 동선 발생 빈도 등 주요 지표를 자동으로 집계하고, 일·주·월 단위 리포트를 관리자에게 제공하여 위험 요소를 체계적으로 파악할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo3,
    },
    {
      title: '감염관리·응급 대응 증빙',
      desc: '이탈, 접촉, 낙상 등 이벤트 기록은 자동 저장되며, 사고 조사 또는 감사 시 증빙 자료로 활용되어 병원의 대응 역량을 향상시킵니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
    {
      title: '병원 IT 시스템과 통합 연동',
      desc: 'EMR, 알람 시스템, CCTV, RFID 및 IoT 솔루션과 연동되어, 환자 위치 정보가 병원 전체 운영 시스템에 실시간 반영됩니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo1,
    },
  ],

  subfunc: {
    title: '주요기능 요약',
    desc: '의료 시설에서 가장 중요한 것은 환자의 건강입니다. 언제 어디서나 환자의 상태는 모니터링되어야 하며, 상황 발생 시 재빠른 초기 대응은 필수적입니다. 오브로는 아래와 같은 기능들을 제공하여, 언제나 안전한 의료 시설을 유지하도록 합니다.',

    data: [
      {
        icon: IconChartRadius,
        title: '리포트 및 분석',
        desc: '환자의 동선 데이터를 기반으로 통계 자료를 만들고 분석할 수 있습니다.',
      },
      {
        icon: IconBell,
        title: '실시간 알람 기능',
        desc: '환자가 동선에 이상 상황이 발생하는 경우 알람을 보내 즉각적으로 대처할 수 있습니다.',
      },
      {
        icon: IconRoute,
        title: '자산 동선 조회',
        desc: '특정 환자의 경로를 추적하여, 안전사고를 예방합니다.',
      },
      {
        icon: IconDashboard,
        title: '현황 파악',
        desc: '현재 특정 환자가 어디로 이동하고 있는지 파악합니다.',
      },
      {
        icon: IconLocation,
        title: '실내 네비게이션',
        desc: '길을 잃은 환자 또는 방문자를 파악하여, 의료 관계자가 찾아가 도움을 줄 수 있습니다.',
      },
      {
        icon: IconUserCheck,
        title: '경험 개선',
        desc: '병원을 방문하는 사람들에게 더 큰 신뢰감을 줄 수 있습니다.',
      },
      {
        icon: IconChainLink,
        title: '데이터 연동',
        desc: 'RFID, IOT, 보안, 영상 등의 시스템과 연결하여 효율적으로 활용할 수 있습니다.',
      },
      {
        icon: IconSecurity,
        title: '데이터 보안',
        desc: '높은 데이터 보안 수준을 유지하여 신뢰성이 높은 솔루션을 제공합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'peoplePackage',
    },
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'medicalWaste',
    },
    {
      data: 'logisticsSafety',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
